import React from 'react';

export const inputStyle: React.CSSProperties = {
    background: '#181a1d',
    color: '#fff',
    border: '1px solid #222',
    borderRadius: 6,
    padding: '14px 16px',
    fontSize: 17,
    outline: 'none',
    marginBottom: 0,
    width: '100%',
    boxSizing: 'border-box',
    fontWeight: 400,
    letterSpacing: 0.2,
    transition: 'border 0.2s',
};

export const passwordInputWrapperStyle: React.CSSProperties = {
    position: 'relative',
    width: '100%',
};

export const passwordInputStyle: React.CSSProperties = {
    ...inputStyle,
    paddingRight: 44,
};

export const passwordToggleButtonStyle: React.CSSProperties = {
    position: 'absolute',
    right: 12,
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    padding: 4,
    cursor: 'pointer',
    color: '#b0b3b8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

export const containerStyle: React.CSSProperties = {
    minHeight: '100vh',
    background: '#111214',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
};

export const formContainerStyle: React.CSSProperties = {
    maxWidth: 420,
    width: '100%',
};

export const headerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 24,
};

export const titleStyle: React.CSSProperties = {
    color: '#fff',
    fontWeight: 700,
    fontSize: 36,
    margin: '16px 0 0 0',
    letterSpacing: 1,
};

export const subtitleStyle: React.CSSProperties = {
    color: '#22d3ee',
    fontSize: 20,
    marginTop: 4,
    marginBottom: 8,
    fontWeight: 400,
};

export const formStyle: React.CSSProperties = {
    background: 'rgba(20,22,25,0.98)',
    borderRadius: 8,
    padding: 32,
    boxShadow: '0 4px 32px 0 rgba(0,0,0,0.45)',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
};

export const errorStyle: React.CSSProperties = {
    color: '#ef4444',
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 8,
};

export const linkStyle: React.CSSProperties = {
    color: '#22d3ee',
    fontSize: 14,
    cursor: 'pointer',
    textDecoration: 'none',
};

export const buttonStyle: React.CSSProperties = {
    background: '#22d3ee',
    color: '#111214',
    fontWeight: 700,
    fontSize: 20,
    border: 'none',
    borderRadius: 6,
    padding: '12px 0',
    marginTop: 8,
    cursor: 'pointer',
    letterSpacing: 1,
    transition: 'background 0.2s',
};

export const footerTextStyle: React.CSSProperties = {
    color: '#b0b3b8',
    fontSize: 15,
    textAlign: 'center',
    marginTop: 18,
};

export const selectStyle: React.CSSProperties = {
    ...inputStyle,
    color: '#fff',
    background: '#181a1d',
}; 